import { render, staticRenderFns } from "./Inspection.vue?vue&type=template&id=36b3ed38&scoped=true&"
import script from "./Inspection.vue?vue&type=script&lang=js&"
export * from "./Inspection.vue?vue&type=script&lang=js&"
import style0 from "./Inspection.vue?vue&type=style&index=0&id=36b3ed38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b3ed38",
  null
  
)

export default component.exports